module.exports = __webpack_public_path__ + "static/media/ImageCollection.1b4e1f77.png";